import React from 'react';
import { Typography } from 'antd';
import { File } from '../../../model/File';
import Constants from '../../../constants/constants';
import JpgImage from '../../../imgs/iconFileJpg.svg';
import PngImage from '../../../imgs/iconFilePng.svg';
import GifImage from '../../../imgs/iconFileGif.svg';
import DocImage from '../../../imgs/iconFileDoc.svg';
import PdfImage from '../../../imgs/iconFilePdf.svg';
import AllImage from '../../../imgs/iconFileAll.svg';
import './DocumentBox.scss';

interface DocumentBoxProps {
  file: File;
}

const DocumentBox = (props: DocumentBoxProps): JSX.Element => {
  let imageType;

  switch (props.file.extension) {
    case 'jpg':
    case 'jpeg':
      imageType = JpgImage;
      break;
    case 'png':
      imageType = PngImage;
      break;
    case 'gif':
      imageType = GifImage;
      break;
    case 'doc':
      imageType = DocImage;
      break;
    case 'pdf':
      imageType = PdfImage;
      break;
    default:
      imageType = AllImage;
  }

  return (
    <a
      href={
        Constants.ServerProtocol +
        '://' +
        Constants.ServerDomain +
        props.file.contentUrl
      }
      target="_blank"
      rel="noreferrer"
    >
      <div className="documentBox">
        <img src={imageType} alt="jpg" />
        <div>
          <Typography.Text className="documentBox__title">
            {props.file.originalName}
          </Typography.Text>
          <Typography.Text className="documentBox__description">
            {props.file.extension}({props.file.size} Мб)
          </Typography.Text>
        </div>
      </div>
    </a>
  );
};

export default DocumentBox;
